export enum AudioChannelSetting {
	Agent0Customer1 = 'Agent0Customer1',
	Agent1Customer0 = 'Agent1Customer0',
	Mono = 'Mono'
}